const AdsHalfStar = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={12} height={12} fill="none">
		<path
			fill="#190A28"
			d="M10.468 4.347 7.641 4.09 6.537 1.371a.575.575 0 0 0-1.075 0L4.357 4.096l-2.821.25c-.514.044-.725.716-.333 1.07L3.347 7.36l-.643 2.884c-.117.526.427.941.87.66L6 9.376l2.425 1.533c.444.281.987-.134.87-.66l-.643-2.89 2.145-1.943c.391-.354.187-1.026-.328-1.07ZM6 8.233V2.55L7 5.02l2.558.232-1.94 1.76.585 2.615-2.203-1.393Z"
		/>
	</svg>
);
export default AdsHalfStar;
